import React from 'react';
import { Navigate } from 'react-router-dom';

export const ProtectedRoute = ({ children }: any) => {
    const accessToken = localStorage.getItem('accessToken');

    // If no accessToken, redirect to /login
    return accessToken ? children : <Navigate to="/login" />;
};